import { Platform } from 'quasar';

export enum PLATFORM {
  IOS = 'ios',
  ANDROID = 'android',
  UNKNOWN = 'unknown',
}

export enum DEVICE {
  MOBILLE = 'mobile',
  DESKTOP = 'desktop',
}

export enum BROWSERS {
  OTHER = 'other',
  CHROME = 'chrome',
  OPERA = 'opera',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  EDGE = 'edge',
}

export default function usePlatformHelpers() {
  function whichBrowser(): IBrowser {
    let browser: IBrowser = BROWSERS.OTHER;

    if (
      navigator.userAgent.indexOf('Edge') > -1 ||
      navigator.userAgent.indexOf('Edg') > -1
    )
      browser = BROWSERS.EDGE;
    else if (Platform.is.chrome) browser = BROWSERS.CHROME;
    else if (Platform.is.opera) browser = BROWSERS.OPERA;
    else if (navigator.userAgent.search('Firefox') > -1)
      browser = BROWSERS.FIREFOX;
    else if (Platform.is.safari) browser = BROWSERS.SAFARI;

    return browser;
  }

  function whichPlatform(): IPlatform {
    if (Platform.is.android) return PLATFORM.ANDROID;
    else if (Platform.is.ios) return PLATFORM.IOS;

    return PLATFORM.UNKNOWN;
  }

  function whichDevice(): IDevice {
    return Platform.is.mobile ? DEVICE.MOBILLE : DEVICE.DESKTOP;
  }

  return { whichDevice, whichPlatform, whichBrowser };
}

export type IDevice = DEVICE;
export type IPlatform = PLATFORM;
export type IBrowser = BROWSERS;
